import React, { FC, memo, useCallback } from 'react'
import SmallButton from '@sport1/news-styleguide/SmallButton'
import NonFlexingContainer from '@sport1/news-styleguide/NonFlexingContainer'
import { useTracking } from '@/utils/tracking/TrackingProvider'

type Props = {
    text?: string
    backgroundColor?: 'pearl'
    onPress: () => void
    shouldTrack?: boolean
}

const LoadMoreButton: FC<Props> = ({
    text = 'Mehr News Laden',
    backgroundColor,
    onPress: onPressProp,
    shouldTrack,
}) => {
    const { trackIvwInfo, trackIvwView } = useTracking()

    const onPress = useCallback(() => {
        onPressProp()
        if (shouldTrack) {
            trackIvwInfo({ ivw_context: text })
            trackIvwView({ ivw_context: text })
        }
    }, [onPressProp, shouldTrack, text, trackIvwInfo, trackIvwView])

    return (
        <NonFlexingContainer
            paddingY={['spacing-6', 'spacing-7', 'spacing-7']}
            paddingX={['spacing-6', 'spacing-9', 'spacing-10']}
            marginBottom={['spacing-7', 'spacing-7', 'spacing-7', 'spacing-9']}
            backgroundColor={backgroundColor}
        >
            <NonFlexingContainer
                marginX={['spacing-none', 'spacing-none', 'auto']}
                width={['100%', '100%', 320]}
            >
                <SmallButton
                    testID="load-more-button"
                    backgroundColor="moon-2"
                    onPress={onPress}
                    expand
                >
                    {text}
                </SmallButton>
            </NonFlexingContainer>
        </NonFlexingContainer>
    )
}

export default memo(LoadMoreButton)
